
const koaToken='22fd03be5b8d486c83764e56395038db'//老系统token
const deviceType="";//设备类型(h5|feishu|android|ios)
const deviceName="";//设备名称(小米|)
const userId="";//账号
const codeType = "";//编码类别
const sapId = "";
const newVersion = "";//区分新系统
const isNewTheme = false;
const workflow_reason="[发自飞书]"; //流程办理意见留言前缀
const NoaSalt="!KingsoftMobileOA#Ver.Sd2@2021";
export default
{
  //codeType 一般传1，表示公司类型为集团
  setLoginInfo(token,koaToken,userId,deviceType,deviceName,codeType,secondLoginType,secondAssessToken,deviceId,sapId)
  {
    this.NoaSalt=NoaSalt;
    this.token=token;
    this.koaToken=koaToken;
    this.userId=userId;
    this.deviceType=this.deviceType && this.deviceType !='' ? this.deviceType : deviceType;
    this.deviceName=deviceName;
    //编码类别，用来区分公司
    this.codeType = codeType?codeType:(this.codeType && this.codeType !=''?this.codeType:"1");
    this.sapId=this.sapId && this.sapId !='' ? this.sapId : sapId;
    this.secondLoginType=secondLoginType;
    this.secondAssessToken=secondAssessToken;
    this.deviceId=deviceId;

    if(deviceType==undefined || deviceType=='')
    {
      //默认为h5
      this.deviceType="h5";
      deviceType="h5";
    }

    if(deviceType=='h5')
    {
      this.workflow_reason="[发自我的H5]";
    }
    else if(deviceType=='feishu')
    {
      this.workflow_reason="[发自我的飞书]";
    }else if(deviceType=='ios')
    {
      this.workflow_reason="[发自我的iPhone]";
    }else if(deviceType=='android')
    {
       if(deviceName!=undefined && deviceName!='')
       {
         this.workflow_reason="[发自"+deviceName+"]";
       }else{
         this.workflow_reason="[发自我的安卓]";
       }
    }
    if((deviceType=='rn'||deviceType=='flutter' )&& codeType == '2')
    {
      this.workflow_reason="[发自西山居移动办公]";
    }
    if(deviceType=='woa' && codeType == '3'){
      this.workflow_reason="[发自金山办公WOA]";
    }

  //   if(token==undefined || token=='' || koaToken==undefined || koaToken=='')
  //   {
  //     //方便测试使用的数据
  //     this.workflow_reason="[发自测试奥]";
  //     //this.token='ee4ba6c5b89743668f9d93d44f2177e8';//dn
  //     this.token='b6eb0e98f2b6408fa4a4a08a823d0535';//LW
  //     //this.token='b42ba59dd6dc43758436c931c8a72b21' //yanghongkun
  //     //this.token='4ecae6bc1cd04982aa1c7938de158204';//wangqianwen
  //     // this.token='afa3c0db1b774ed79a40ab201d55be7b';//zongjianli
  //     //this.token='e12a28d983a8471f80ace3cf4c37070c';//jiangzhenyuan
  //     // this.token='728b987cabcc4653894d8f258c7fc83a' //liuzewen
  //     //this.token='f8f153c949034aedac04fdf14aa474bc';//liqiang6
  //     //this.token='9b74213ecbc04e89aa4f64a7d66eb5e9';//zhangyi
  //     //this.token='612a6a780ec545ff99a11444b3788214' //zhouyu2
  //    //this.token='82e5613fc40f49e1a328b8fcd886cb8f';//kso huangkelie
  //    //this.token='8726c5d1c2e944afacd888faf6cba74d';//kso zhangqiange
  //     //this.token='cb24dda060714f6daeb51d2ece0b57bf' //ksc wangsen2
  //     //this.token='2a45c70f55764a6fa6549d6fa148a7f3';//ksc chenyijun
  //     //this.token='b7a15dc852824fd9a44cc7b063151b68';//ksc zhujiang
  //     //this.token='7742821461014efd9792e810fef9e16c'//ksc yujun2
  //     //this.token='b3dc6ffb4458420c9c589e23d2acce0a' //成都 考勤 HUANGHONGHUI
  //     // this.token='fc6f52b576724c9dadd2fa5befd4f43c' //成都 考勤 YIQIAN
  //     // this.token='7587feb0b0384fd897f3ad139e9b44e8' //成都 考勤 ZENGRONGZHU
  //    //this.token='24adbf2fe1ce4ca9ac021c073274a619';//leizekun
  //    //this.token='ff1fa651c7a144ed898225c530b56315' //sunduoliang
  //    //this.token='aa5a08f2c30e4b869444d95f1ae713b0' //sunhongyin
  //     //kcpToken  fc7c3ae77bb4449ab9a42148d172a3f5     token	6d32bafbab8c48f89acc7d7b9e264ad3
  //  // this.token='35f68ac675584b75bcfc5f64e4bd63ca' //huangkelei
  //  // this.token='8726c5d1c2e944afacd888faf6cba74d';//kso zhangqiange
  // //this.token='2e1928f88de44c4f8940cd45f08b4731' ;//songguosen

  // // this.token='a980ea32f00849b59e2b9b8493220adc' //duyujie
  // // this.token='96cdb4ee139a4921812dbe767c04d88e'; //wangjing2
  // //this.token='cbd983dd9da4434fb01a8ed5da61da33'
  //     this.koaToken='b6eb0e98f2b6408fa4a4a08a823d0535'//老系统token
  //   }

  },
  //codeType 一般传1，表示公司类型为集团
  setLoginInfoOpen(token,koaToken,userId,deviceType,deviceName,secondLoginType,secondAssessToken,deviceId)
  {
    this.NoaSalt=NoaSalt;
    this.token=token;//二次登陆token
    this.koaToken=koaToken;
    this.userId=userId;
    this.deviceType=this.deviceType && this.deviceType !='' ? this.deviceType : deviceType;
    this.deviceName=deviceName;
    this.secondLoginType=secondLoginType;
    this.secondAssessToken=secondAssessToken;
    this.deviceId=deviceId;
    if(deviceType==undefined || deviceType=='')
    {
      //默认为h5
      this.deviceType="h5";
      deviceType="h5";
    }

    if(deviceType=='h5')
    {
      this.workflow_reason="[发自我的H5]";
    }
    else if(deviceType=='feishu')
    {
      this.workflow_reason="[发自我的飞书]";
    }else if(deviceType=='ios')
    {
      this.workflow_reason="[发自我的iPhone]";
    }else if(deviceType=='android')
    {
       if(deviceName!=undefined && deviceName!='')
       {
         this.workflow_reason="[发自"+deviceName+"]";
       }else{
         this.workflow_reason="[发自我的安卓]";
       }
    }
    if((deviceType=='rn'|| deviceType=='flutter')&& codeType == '2')
    {
      this.workflow_reason="[发自西山居移动办公]";
    }

    // if(token==undefined || token=='' || koaToken==undefined || koaToken=='')
    // {
    //   //方便测试使用的数据
    //   this.workflow_reason="[发自测试奥]";
    //   this.token='b3dc6ffb4458420c9c589e23d2acce0a' //成都 考勤 HUANGHONGHUI
    //   this.koaToken='b6eb0e98f2b6408fa4a4a08a823d0535'//老系统token
    // }

  },
  //codeType 一般传1，表示公司类型为集团
  setLoginInfoBatch(token,koaToken,userId,deviceType,codeType,newVersion,secondLoginType,secondAssessToken,deviceId)
  {
    this.NoaSalt=NoaSalt;
    this.token=token;
    this.koaToken=koaToken;
    this.userId=userId;
    this.deviceType = this.deviceType && this.deviceType !='' ? this.deviceType : deviceType;
    this.codeType = codeType?codeType:(this.codeType && this.codeType !=''?this.codeType:"1");
    this.newVersion = newVersion?newVersion:"0";

    this.secondLoginType=secondLoginType;
    this.secondAssessToken=secondAssessToken;
    this.deviceId=deviceId;
  },
  //普通非流程方法调用存储缓存信息
  setLoginInfoCommon(token,koaToken,userId,deviceType,secondLoginType,secondAssessToken,deviceId){
    this.NoaSalt=NoaSalt;
    this.token=token;
    this.koaToken=koaToken;
    this.userId=userId;
    if(deviceType==undefined || deviceType=='')
    {
      //默认为h5
      this.deviceType="h5";
      deviceType="h5";
    }
    this.deviceType = deviceType;

    this.secondLoginType=secondLoginType;
    this.secondAssessToken=secondAssessToken;
    this.deviceId=deviceId;
  },

  setKscircleAuthorInfo(kscirToken) {
    this.NoaSalt=NoaSalt;
    this.kscirToken = kscirToken
  }
};



// WEBPACK FOOTER //
// ./src/utils/Global.vue